import { denormalize } from 'normalizr';
import * as Schema from '../schema';

export const STATE_KEY = 'metadata';

const GLOBAL_ID = 'global';

export function reducer(state = {}, action) {
  switch(action.type) {
  default:
    return state;
  }
}

const getMetadata = (store) => denormalize(GLOBAL_ID, Schema.metadata, store.getState());

export function getFeaturedCollection(store) {
  const metadata = getMetadata(store);
  return metadata.featuredCollection;
}



// WEBPACK FOOTER //
// ./src/store/modules/metadata.js